import home1 from "../../assets/img/IMG-20251108-WA0051.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function LandScapeDesign() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h6>Creating Outdoor Spaces That Inspire</h6>
                <h3>About Landscape Design</h3>

                <p>
                  Landscape design is more than just making a place look
                  beautiful — it’s about creating spaces that feel right. It’s
                  the art of shaping outdoor areas to bring balance between
                  nature and the way we live.
                </p>
                <p>
                  A good landscape design doesn’t just add plants or stones; it
                  adds meaning. It’s about how sunlight falls in the morning,
                  how a breeze moves through the garden, how the smell of wet
                  soil makes you pause for a moment. These little things turn an
                  ordinary space into a living experience.
                </p>
                <p>
                  Real landscape design always begins with understanding the
                  land — its soil, light, and flow. Then comes the human part:
                  how people will walk, sit, rest, and connect with it. Whether
                  it’s a courtyard filled with native trees, a small balcony
                  garden, or a large outdoor retreat, the goal is the same — to
                  create harmony between people and the earth.
                </p>
                <p>
                  True beauty in a landscape doesn’t come from how expensive it
                  looks, but from how naturally it fits into its surroundings.
                  Simplicity, sustainability, and a touch of personal expression
                  make a design feel authentic and alive.
                </p>
                <p>
                  In the end, a well-designed landscape doesn’t just decorate a
                  place — it changes how you feel when you’re there.
                </p>
              </div>
              <div className="fisherman-content">
                <h4>🌍 Types of Landscape Design Styles</h4>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Style</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Formal</strong>
                      </td>
                      <td>
                        Symmetrical, geometric layout with neatly trimmed
                        plants.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Informal</strong>
                      </td>
                      <td>Organic shapes, curved paths, natural groupings.</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Modern</strong>
                      </td>
                      <td>Clean lines, minimalist design, sleek materials.</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Tropical</strong>
                      </td>
                      <td>Lush foliage, bold colors, and dramatic textures.</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Mediterranean</strong>
                      </td>
                      <td>
                        Warm colors, drought-tolerant plants, gravel paths.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Japanese</strong>
                      </td>
                      <td>
                        Minimalist, symbolic, with water and stone elements.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
               <div class="fisherman-content">
            <h5>Ready to Transform Your Outdoor Space?</h5>
            <p>
              Let us help you bring your landscape vision to life. Whether it's
              a peaceful backyard oasis, a pollinator garden, or a bold modern
              courtyard — we’ll guide you from concept to completion.
            </p>
            <Link href="mailto:info@example.com" className="commonButton mt-3">
              📧 Contact Us
            </Link>
          </div>
              <div className="fisherman-content d-none">
                <h4>🧩 Key Elements of Landscape Design</h4>
                <ul>
                  <li>
                    <strong>Line</strong> – Defines boundaries and movement
                    (paths, fences, edges).
                  </li>
                  <li>
                    <strong>Form</strong> – Shapes in the landscape, from round
                    trees to angular patios.
                  </li>
                  <li>
                    <strong>Color</strong> – Sets the tone and mood through
                    plants, flowers, and materials.
                  </li>
                  <li>
                    <strong>Texture</strong> – Adds contrast and interest
                    (smooth grass vs. rough stone).
                  </li>
                  <li>
                    <strong>Scale & Proportion</strong> – Ensures harmony
                    between features and the surrounding space.
                  </li>
                  <li>
                    <strong>Unity & Balance</strong> – Brings everything
                    together in a visually pleasing and functional way.
                  </li>
                </ul>
              </div>
              <div className="fisherman-content d-none">
                <h4>🏡 Components of a Landscape</h4>
                <ul>
                  <li>
                    <strong>Softscape:</strong> Trees, shrubs, flowers, grass,
                    ground covers
                  </li>
                  <li>
                    <strong>Hardscape:</strong> Patios, walkways, walls, decks,
                    fences, fire pits
                  </li>
                  <li>
                    <strong>Water Features:</strong> Ponds, fountains,
                    waterfalls, pools
                  </li>
                  <li>
                    <strong>Lighting:</strong> Pathway lights, accent lighting,
                    safety lighting
                  </li>
                  <li>
                    <strong>Outdoor Structures:</strong> Pergolas, arbors,
                    gazebos, seating areas
                  </li>
                </ul>
              </div>

              <div className="fisherman-content d-none">
                <h4>🛠️ The Landscape Design Process</h4>
                <ol>
                  <li>
                    <strong>Site Analysis</strong> – Understand the land, soil,
                    sunlight, wind, and drainage.
                  </li>
                  <li>
                    <strong>Define Goals</strong> – Identify how the space will
                    be used (relaxation, entertainment, play, etc.).
                  </li>
                  <li>
                    <strong>Concept Development</strong> – Sketch layout ideas,
                    themes, and zones.
                  </li>
                  <li>
                    <strong>Design Drafting</strong> – Detailed plans with
                    measurements, plant choices, and materials.
                  </li>
                  <li>
                    <strong>Installation</strong> – Construction, planting, and
                    placement of features.
                  </li>
                  <li>
                    <strong>Maintenance Planning</strong> – Schedule for
                    watering, pruning, and seasonal care.
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div className="fisherman-content d-none">
            <h4>🌱 Sustainable Landscape Design</h4>
            <ul>
              <li>
                <strong>Native plants</strong> that require less water and
                maintenance
              </li>
              <li>
                <strong>Efficient irrigation systems</strong> (e.g., drip
                irrigation)
              </li>
              <li>
                <strong>Rain gardens</strong> and{" "}
                <strong>permeable paving</strong> for stormwater management
              </li>
              <li>
                <strong>Pollinator-friendly gardens</strong> to support local
                ecosystems
              </li>
            </ul>
          </div>

         
        </div>
      </section>
    </>
  );
}

export default LandScapeDesign;
